
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'


function Order() {


    const [orderData, setorderData] = useState({})
    




  const fetch=async()=>{

    let userEmail= localStorage.getItem("UserEmail");
    await axios.post('https://gofoodies.onrender.com/getOrderData',{
      email:userEmail,
    })
    .then(result=>{
       console.log(result.data.data)
      setorderData(result.data.data)
      
  })
  .catch(err=>{
    console.log(err.response.data.msg)
    alert(err.response.data.msg)
  })


//   let x=Array(orderData).map((y)=>{

//     console.log(y.order_data)
//   })





  }

  useEffect(()=>{
     fetch()
  },[])




    return (
        <div>

            <div>
                <Navbar />
            </div>

            <div className='container'>
                <div className='row'>


                    {orderData !== {} ? Array(orderData).map(data => {
                        return (
                            data.orderData ?
                                data.orderData.order_data.slice(0).reverse().map((item) => {
                                    return (
                                        item.map((arrayData) => {
                                            return (
                                                 

                                                <div  >
                                                
                                                    { arrayData.Order_date ? <div className='m-auto mt-5'>
                                                        
                                                        {data = arrayData.Order_date}
                                                        <hr />
                                                    </div> :
                                                        
                                                        <div className='col-12 col-md-6 col-lg-3' >
                                                            <div className="card mt-3" style={{ width: "16rem", maxHeight: "360px" }}>
                                                            
                                                                <img src={arrayData.img} className="card-img-top" alt="..." style={{ height: "120px", objectFit: "fill" }} />
                                                                <div className="card-body">
                                                                    <h5 className="card-title">{arrayData.name}</h5>
                                                                    <div className='container w-100 p-0' style={{ height: "38px" }}>
                                                                        <span className='m-1'>{arrayData.qty}</span>
                                                                        <span className='m-1'>{arrayData.size}</span>
                                                                        <span className='m-1'>{data}</span>
                                                                        <div className=' d-inline ms-2 h-100 w-20 fs-5' >
                                                                            ₹{arrayData.price}/-
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>



                                                    }

                                                </div>
                                            )
                                        })

                                    )
                                }) : <div className='container text-center text-success mt-5'>
                                     <h1>Order Placed succesfully </h1>
                                     <h2 >Have a Nice Day {}</h2>
                                     <h3 className='text-warning'>Rahul@</h3>
                                     <p className='text-danger mt-3'>This page is in Working condition !!!</p>
                                </div>
                        )
                    }) : <h1>Rahul</h1>}






                </div>

            </div>


            <div className='mt-5'>
                <Footer />
            </div>


        </div>
    )
}

export default Order
